import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getSpinnerStyles = (theme: Theme) => css({ marginTop: theme.spacing(4) });
